import React from "react";

// pass Question and Options if needed
function QnA({layer, response, audience, onSelectoption, selectedAnswer}) {
  const { question, options } = layer;
  const groupName = `path-multiple-choice-${layer?.id || 'question'}`;

  return (
    <div className="cover-question-form-block">
      <div className="list-question-form-block">
        <div className="item-list-question-form-block active">
          <div className="title-question-form-block">{question}</div>
          <div className="list-question-form">
            {options?.map((option, index) => {
              const isChecked = audience ? selectedAnswer === option.value : option?.isChecked;

              return(
                <div key={option.id || `${groupName}-${index}`} className="item-list-question-form">
                  <div
                    className="cover-radio-question-form"
                    onClick={() => audience ? onSelectoption(option) : null}
                  >
                    <div className="radio">
                      <label>
                        <input
                          className="icon-question-form"
                          type="radio"
                          name={groupName}
                          checked={Boolean(isChecked)}
                          onChange={() => audience ? onSelectoption(option) : null}
                        />
                        <span className="text-radio-question-form">{option.value}</span>
                      </label>
                    </div>
                  </div>
                  {/* <div
                    className={`cover-radio-question-form ${option?.isChecked ? "correct-ans" : ""}`}
                    for="currently-employed"
                  >
                    <span className="icon-question-form"></span>
                    <span className="text-radio-question-form">{option.value}</span>
                  </div> */}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default QnA;
